/**
 *
 * @description: 银华
 *
 */
import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'yh';
const comein_channel = isBuild ? 'c5a2dc91-2025-4ecd-a071-7f79db38822a' : 'c889361d-39ab-4669-8da0-4f4e5609c589';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'yh';

// 银华Bridge类 - 继承基类，使用空的empowerAlert函数
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false, () => {}); // 传递空的empowerAlert函数
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

// 同时导出类（用于 bridge.js 的原型链合并）
export { Bridge };
